<template>
  <v-navigation-drawer v-bind="$attrs" v-on="$listeners" :value="value" @input="v => $emit('input', v)">
    <slot></slot>
  </v-navigation-drawer>
</template>

<script>
import uuid4 from '@/utils/uuid.js';

export default {
  name: 'navigation-drawer-scroll-lock',

  props: { value: Boolean },

  destroyed() {
    this.$delete(this.global.scrollLock, this.uuid);
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.uuid ||= uuid4();
        this.$set(this.global.scrollLock, this.uuid, v);
      }
    }
  }
}
</script>
